module.exports = __webpack_public_path__ + "assets/img/member_vip.b8665432.png";